import { ModelSagres } from "../../model-sagres"

export class AssinaturaDeContasMensal extends ModelSagres {
    IdPrestacaoConta: number
    LabelSignatario: string
    UsuarioResponsavel: string
    NomeSignatario: string
    CpfResponsavel?: string | null
    CpfCnpjSignatario?: string | null
    DataAssinatura: Date
    ConteudoArquivoAssinado?: string
    CodSignatario: string
    IdTipoCertificado?: number
    Status: string
    Actions: string
}